import React, { createContext, useContext, useState, useCallback } from 'react';

interface LoginModalContextType {
  isOpen: boolean;
  intendedRoute: string | null;
  openModal: (intendedRoute?: string) => void;
  closeModal: () => void;
}

const LoginModalContext = createContext<LoginModalContextType | undefined>(undefined);

export function LoginModalProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [intendedRoute, setIntendedRoute] = useState<string | null>(null);

  const openModal = useCallback((route?: string) => {
    setIsOpen(true);
    setIntendedRoute(route || null);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setIntendedRoute(null);
  }, []);

  return (
    <LoginModalContext.Provider
      value={{
        isOpen,
        intendedRoute,
        openModal,
        closeModal,
      }}
    >
      {children}
    </LoginModalContext.Provider>
  );
}

export function useLoginModal(): LoginModalContextType {
  const context = useContext(LoginModalContext);
  if (context === undefined) {
    throw new Error('useLoginModal must be used within a LoginModalProvider');
  }
  return context;
}

